import React, { useState } from 'react';
import { TimePicker } from 'components/LegacyPickers';
import jMoment from 'moment-jalaali';
import { DatePickerPod, SimpleDialog, Icons } from 'components';
import { Button, Grid } from '@mui/material';
import persianJs from 'persianjs';
import { enifyDateTime } from 'utility';

const FilterDateTimeRange = ({ onFilterChanged, defaultTime = null, columnDef, ...rest }) => {
  const [time, setTime] = useState(
    defaultTime ? enifyDateTime(defaultTime?.format('HH:mm:ss')) : '',
  );
  const [timeFilter, setTimeFilter] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  const handleChangeTime = (e) => {
    if (!e) {
      setTime('');
      setTimeFilter('');
    } else {
      setTime(e);
      setTimeFilter(jMoment(e).format('HH:mm:ss'));
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleResetFilter = () => {
    handleChangeTime(null);
  };

  const submitDialog = (resetFilter) => {
    setOpenDialog(false);
    const reset = resetFilter === true && !defaultTime;
    if (reset) {
      handleResetFilter();
    }

    let enTimeFilter = timeFilter;

    enTimeFilter = enTimeFilter ? persianJs(enTimeFilter).toEnglishNumber().toString() : null;

    onFilterChanged(columnDef.tableData.id, reset ? null : enTimeFilter);
  };

  const openDialogTime = () => {
    const newDate = new Date();
    const time = jMoment(newDate).format('HH:mm:ss');
    let timeObj;

    if (!timeFilter) {
      timeObj = time;
    } else {
      timeObj = timeFilter;
    }

    setTimeFilter(timeObj);
    setOpenDialog(true);
  };

  const ActionsBtn = () => {
    return (
      <>
        <Button variant="contained" color="primary" onClick={submitDialog}>
          اعمال
        </Button>

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
        <Button
          startIcon={<Icons icon='CloseSmall' color='#ccc' size='20' />}
          variant="contained"
          onClick={() => {
            submitDialog(true);
          }}
        >
          حذف فیلتر
        </Button>
      </>
    );
  };

  return (
    <>
      <Button fullWidth onClick={() => openDialogTime()} variant="outlined">
        انتخاب ساعت
      </Button>

      <SimpleDialog
        style={{ overflowX: 'hidden' }}
        fullWidth
        maxWidth="xs"
        open={openDialog}
        title="انتخاب ساعت"
        onClose={handleCloseDialog}
        actions={<ActionsBtn />}
      >
        <Grid container alignItems="center" justifyContent="center" spacing={3}>
          <Grid item xs={6}>
            <DatePickerPod>
              <TimePicker
                {...rest}
                // autoOk
                fullWidth
                views={['hours', 'minutes', 'seconds']}
                inputVariant="outlined"
                showTodayButton
                todayLabel="امروز"
                okLabel="تایید"
                cancelLabel="لغو"
                clearLabel="پاک کردن"
                labelFunc={(time) => (time ? time.format('HH:mm:ss') : '')}
                value={time || null}
                onChange={handleChangeTime}
                disableFuture
              />
            </DatePickerPod>
          </Grid>
        </Grid>
      </SimpleDialog>
    </>
  );
};

export default FilterDateTimeRange;
